import { Injectable } from '@angular/core';
import { RestClientService } from 'src/app/core/services/rest/rest-client.service';
import { PageRequestInstanceDTO } from 'src/app/parametrage/core/model/page-request-instance-dto';
import { PageRequest } from 'src/app/parametrage/core/model/page-request';
import { PageCorrectionHistory } from 'src/app/mon-portefeuille/core/model/page-correction-history';
import { CreateDossierParticulier } from '../model/particulier/create-dossier-particulier';
import { HttpClient } from '@angular/common/http';
import { PageCorrectionsHistory } from 'src/app/parametrage/core/model/PageCorrectionHistoryDTO';
import { PageDemandeResurmeDTO } from 'src/app/parametrage/core/model/page-demande-resurme-dto';
import { PageRequestDTO } from 'src/app/core/services/business/model/page-request-dto';

@Injectable({
    providedIn: 'root'
  })
  export class ParticulierService{

    constructor(private http: HttpClient,private _restClientService : RestClientService) 
    {}

    
    createDossier(createDossierParticulier: CreateDossierParticulier)
    {
      return  this._restClientService.save<void>('particulier/create-dossier', createDossierParticulier);
    }

    
    findAllDossierEncours(filter,page,size) 
    {
        return this._restClientService.load<PageRequestInstanceDTO>('particulier/find-all-dossier-encours'
        +'?filter='+filter
        +'&page='+page
        +'&size='+size
        );
    }
    
    findAllDossierAbandonne(filter,page,size) 
    {
        return this._restClientService.load<PageRequestInstanceDTO>('particulier/find-all-dossier-abandonne'
        +'?filter='+filter
        +'&page='+page
        +'&size='+size
        );
    }
    
    findAllDossierCloture(filter,state,page,size) 
    {
        return this._restClientService.load<PageRequest>('particulier/find-all-dossier-cloture'
        +'?filter='+filter
        +'&state='+state
        +'&page='+page
        +'&size='+size
        );
    }
    
    findAllDossier(filter,state:String[], debut, fin, page, size, sortColumn, direction) 
    {
        return this._restClientService.load<PageRequestDTO>('particulier/find-all-dossier'
        +'?filter='+filter
        +'&state='+state
        +'&debut='+debut
        +'&fin='+fin
        +'&page='+page
        +'&size='+size
        +'&sortColumn='+sortColumn
        +'&direction='+direction
        );
    }
    
    findAllDossierAcorriger(filter, page, size, sortColomun, descending) 
    {
        return this._restClientService.load<PageCorrectionHistory>('particulier/find-all-dossier-a-corriger'
        +'?filter='+filter
        +'&page='+page
        +'&size='+size
        +'&sortColomun='+sortColomun
        +'&descending='+descending
        );
    }
    


    findAllDossierClotureCardView(filter, state, page, size) {
        return this._restClientService.load<PageDemandeResurmeDTO>(
          "particulier/find-all-dossier-cloture-card-view" +
            "?filter=" +
            filter +
            "&state=" +
            state +
            "&page=" +
            page +
            "&size=" +
            size
        );
    }


    findAllDossierAcorrigerCardView(filter, page, size, sortColomun, descending) {
        return this._restClientService.load<PageCorrectionsHistory>(
          "particulier/find-all-dossier-a-corriger-card-view" +
            "?filter=" +
            filter +
            "&page=" +
            page +
            "&size=" +
            size +
            "&sortColomun=" +
            sortColomun +
            "&descending=" +
            descending
        );
    }
    
}      

    